/*
 * @Author: Claude
 * @Date: 2025-12-31
 * @Description: 通用上传占位符组件
 */
import { FC, ReactNode } from 'react';

import { UploadIcon } from '@/components/icons';

interface UploadPlaceholderProps {
  /** 提示文本（可以是字符串或 ReactNode） */
  tips?: string | ReactNode;
  /** 点击事件 */
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * 通用上传占位符组件
 * 用于显示上传区域的提示信息和图标
 */
export const UploadPlaceholder: FC<UploadPlaceholderProps> = ({ tips, onClick }) => {
  return (
    <div
      className="flex flex-col items-center justify-center gap-[5px] px-[8px] py-[16px] w-full border-[1px] h-[155px] rounded-[8px] select-none"
      onClick={onClick}
    >
      {/* 上传图标 */}
      <UploadIcon />

      {/* 提示文本 */}
      {tips && (
        <p className="text-[10px] text-[rgba(17,17,17,0.6)] text-center leading-[20px] mb-[8px]">
          {tips}
        </p>
      )}
    </div>
  );
};
